import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const AccumulatedPortfolioCard = ({ portfolio }) => {
  const theme = useTheme();
  const { gapGreen, gapRed } = theme.custom.colors;

  if (!portfolio) return null;

  const isGain = portfolio.total_notional_gain_loss?.is_gain === true;
  const chipColor = isGain ? gapGreen : gapRed;

  return (
    <Box sx={{ bgcolor: 'background.default', borderRadius: 2, p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="labelD">Accumulated Portfolio</Typography>
        <Typography variant="labelS" color="text.secondary">
          {portfolio.account_count} ACCOUNTS
        </Typography>
      </Box>
      <Box sx={{ background: '#995A000D', p: 1, borderRadius: 1, gap: 1, display: 'flex', flexDirection: 'column'}}>
        <Box sx={{ display: 'flex', gap: 2, justifyContent:'space-between' }}>
          <Box sx={{ flex: 1, background: '#fff', p: 1, borderRadius: 1,}}>
            <Typography variant="labelD">{portfolio.current_value?.label}</Typography>
            <Typography variant="h1" color="primary.main">{portfolio.current_value?.value}</Typography>
          </Box>
          <Box sx={{ flex: 1, textAlign: 'end'  }}>
            <Typography variant="labelD">{portfolio.invested_amount?.label}</Typography>
            <Typography variant="h1" color="primary.main">{portfolio.invested_amount?.value}</Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              px: 1,
              py: 0.5,
              borderRadius: '32px',
              border: `1px solid ${chipColor}`,
              background: alpha(chipColor, 0.12),
              flexShrink: 0,
            }}
          >
            <Typography variant="labelD" sx={{ whiteSpace: 'nowrap' }}>
              {portfolio.total_notional_gain_loss?.value}
            </Typography>
          </Box>
          <Typography variant="labelD" color="text.secondary">
            {portfolio.total_notional_gain_loss?.label?.toUpperCase()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AccumulatedPortfolioCard;
